<template>
  <div>
    <div
      class="input-group"
      :class="{
        'focus': focused,
        'invalid': $v.$error,
      }"
    >
      <input
        :id="inputIdMonth"
        v-model="month"
        v-regexp="/^\d+$/"
        type="tel"
        :title="$t('enter.date.month')"
        :placeholder="$t('date.month.abbreviated')"
        :size="inputSize"
        class="input-field tiny"
        autocomplete="cc-exp-month"
        data-private
        @focus="checkReset"
        @input="onMonth"
        @blur="checkLength"
        @keyup.delete="onMonthDelete"
      />

      <span></span>

      <input
        :id="inputIdYear"
        v-model="year"
        v-regexp="/^\d+$/"
        v-maxLengthForDateAutocomplete
        type="tel"
        :title="$t('enter.date.year')"
        :placeholder="$t('date.year.abbreviated')"
        :size="inputSize"
        class="input-field tiny"
        autocomplete="cc-exp-year"
        data-private
        @focus="checkReset"
        @input="onYear"
        @blur="checkLength"
        @keyup.delete="onYearDelete"
      />
    </div>

    <label :for="inputIdMonth">
      <span>{{ $t('enter.card.date') }}</span>
    </label>
  </div>
</template>

<script>
import { required, between } from 'vuelidate/lib/validators';

let currentYear = parseInt(new Date().getFullYear().toString().substr(-2));
let expiredYear = currentYear + 10;
let currentMonth = new Date().getMonth()+1;
let _canPrevYear = true;

export default {
  props: {
    inputIdYear: String,
    inputIdMonth: String,
    inputSize: { type: String, default: '3' },
  },
  data() {
    return {
      month: '',
      year: '',
      focused: false,
      isMonth: false,
      isYear: false,
    };
  },
  validations() {
    return {
      month: {
        required,
        between: between(1, 12),
      },
      year: {
        required,
        between: between(currentYear, expiredYear),
        afterCurrentDate() {
          return !(
            Number(this.month) < currentMonth && Number(this.year) === currentYear
          );
        },
      },
    };
  },
  methods: {
    // eslint-disable-next-line complexity
    onMonth() {
      // _canPrevMonth = undefined;
      if (!/[0-9]/.test(this.month)) { this.month = this.month.slice(0, -1); }

      if (this.month.length === 1 && !/[0-1]/.test(this.month)) {
        this.month = '0' + this.month;
        this.isMonth = true;
      } else if (this.month.length >= 2 && !this.$v.month.between) {
        if (this.month.length > 2) {
          this.month = this.month.slice(0, -1);
        } else {
          this.month = '12';
        }
        this.isMonth = true;
      } else if (this.month.length === 2 && this.$v.month.between) {
        this.isMonth = true;
      }

      if (this.month.length === 2 && this.isMonth) {
        this.$emit('focusNext');
        this.$emit('onMonth', this.month);
      }
    },
    onYear() {
      _canPrevYear = undefined;

      if (this.year.length >= 2 && !this.$v.year.between) {
        this.$v.$touch();
        this.isYear = false;
      } else { this.isYear = true; }

      if (this.year.length === 2 && this.isYear) {
        if (!this.$v.year.afterCurrentDate) {
          this.$v.$touch();
          this.isMonth = false;
        } else {
          this.$emit('focusNext');
          this.$emit('onYear', this.year);
        }
      }
    },
    onMonthDelete() {
      this.checkReset();
      this.$emit('onMonth', false);
      // Решили не делать в этом поле возврат в предыдущее (CPME-859).
      // _canPrevMonth && this.$emit('focusPrev');
      // _canPrevMonth = this.month ? undefined : true;
    },
    onYearDelete() {
      this.checkReset();
      this.$emit('onYear', false);

      if (_canPrevYear) {
        this.$emit('focusPrev');
      }

      _canPrevYear = this.year ? undefined : true;
    },
    checkLength() {
      this.focused = false;

      if (this.month.length !==2 || this.year.length !==2) {
        this.$v.$touch();
      }
    },
    checkReset() {
      this.focused = true;
      this.$v.$reset();
    },
    reset() {
      this.month = '';
      this.year = '';
    },
  },
};
</script>

<style lang="sass" scoped>
.input.narrow
  .input-group
    display: flex
    input
      flex-grow: 0
      max-width: 2.8rem

    & input:not(:placeholder-shown) + span
      margin-left: -6px
    &:not(.focus) input:not(:placeholder-shown) + span
      border-color: #FFFFFF

    span
      position: relative
      margin: 6px 10px
      border-left: 2px solid $placeholder-color
      transform: skewX(-30deg)
</style>
